const preference = matchMedia("(prefers-reduced-motion: reduce)");
// Explicit preview override makes the same reduced-motion path easy to verify.
const forced = new URLSearchParams(location.search).get("motion") === "reduce";
export const reducedMotion = {
  get matches() {
    return forced || preference.matches;
  },
  removeEventListener(type, callback) {preference.removeEventListener(type, callback);},
  addEventListener(type, callback) {
    preference.addEventListener(type, callback);
  },
};
function sync() {
  document.documentElement.toggleAttribute(
    "data-reduced-motion",
    reducedMotion.matches,
  );
}
sync();
preference.addEventListener("change", sync);
